import https from "./https";
import store from "@/store";

const webhookEvent = {
  getWebhookEvents(params) {
    const organization = store.state.general.organization;
    const searchParams = new URLSearchParams(params);

    return https.get(
      `/admin/organizations/${organization.id}/webhook-events?${searchParams}`
    );
  },
};

export default webhookEvent;
